import { render, staticRenderFns } from "./UsersView.vue?vue&type=template&id=2ce2b31e&"
import script from "./UsersView.vue?vue&type=script&lang=js&"
export * from "./UsersView.vue?vue&type=script&lang=js&"
import style0 from "./UsersView.vue?vue&type=style&index=0&id=2ce2b31e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports